import type { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { createTheme } from '@/lib/theme';

const LIGHT = createTheme({ mode: 'light' });

/**
 * The public shell — home page, Login, Register, the public upload link, the
 * error pages — is parchment in every theme (uiv2 PUB-16/17). The theme is a
 * signed-in preference kept in localStorage, so it survives sign-out and a
 * shared device: without this, a visitor could meet a dark sign-in form. Two
 * halves, because antd and our CSS read colour from different places: this
 * pins antd's tokens to light, and `.bs-light-scope` (tokens.css) pins every
 * `var(--…)` the page's own styles use. Locale and direction are inherited.
 */
export function PublicTheme({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider theme={LIGHT} getPopupContainer={popupContainer}>
      {children}
    </ConfigProvider>
  );
}

/**
 * antd renders a dropdown into <body> — OUTSIDE `.bs-light-scope`, where every
 * var() reads the dark theme. Measured on Register under a stored dark theme:
 * the role list was rgb(38,32,25) behind rgb(30,24,18) text — dark on dark,
 * because the light algorithm's text met the dark scope's surface. A popup is
 * placed inside the trigger's scope instead.
 */
function popupContainer(trigger?: HTMLElement): HTMLElement {
  return trigger?.closest<HTMLElement>('.bs-light-scope') ?? document.body;
}
